import type { AccountRole, StaffRole } from './entities.js';

export const ACCOUNT_ROLE_LABELS: Record<AccountRole, string> = {
  member: 'User',
  business: 'Business',
  moderator: 'Moderator',
  editor: 'Editor',
  administrator: 'Administrator',
  owner: 'Owner',
};

export function accountRoleLabel(role: AccountRole): string {
  return ACCOUNT_ROLE_LABELS[role];
}

/** UI gates consume a server-authorized role; role assignment alone grants no access. */
export function isStaffRole(role: AccountRole): role is Exclude<StaffRole, 'member'> {
  return ['owner', 'administrator', 'moderator', 'editor'].includes(role);
}

export function canManageCatalogRole(role: AccountRole): boolean {
  return role === 'owner' || role === 'administrator' || role === 'editor';
}
